import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'

import { KVMessageDef } from './index'

export function getConfirmIdMessage() {
  return {
    type: 'confirmId',
    requiredData: ['confirm'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (!kv.pixelStream) return
      kv.setViewerId(json.confirm as string)
      kv.pixelStream.emitUIInteraction({
        confirmId: json.confirm,
        confirmName: kv.user.name,
      })
    },
  } as KVMessageDef
}
